import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

import { styleVariables } from '@lib/common';
import { Progress, Skeleton, Card, Badge } from 'antd';
import styled from '@xstyled/styled-components';
import { SubmissionScore, SubmissionStatusId } from '@module/assignment';
import { LoadingOutlined } from '@ant-design/icons';
import { RequestStatus } from '@module/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledSkeleton = styled(Skeleton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  padding: ", ";\n"])), styleVariables.padding.medium); // New card-based layout components

var StyledAttendeeCard = styled(Card)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 8px;\n  border-radius: ", ";\n  border: ", ";\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    border-color: ", ";\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .ant-card-body {\n    padding: ", ";\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), styleVariables.borderRadius.medium, function (props) {
  return props.$isSelected ? "2px solid ".concat(props.theme.color.primary) : "1px solid ".concat(props.theme.color.borderDefault);
}, function (props) {
  return props.theme.color.primary;
}, styleVariables.padding.medium);
var StyledAttendeeName = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  margin-bottom: ", ";\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n"])), styleVariables.font.fontSizeOriginal, styleVariables.font.fontWeightStrong, function (props) {
  return props.theme.color.textTitle;
}, styleVariables.margin.medium);
var StyledStatusLabel = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 10px;\n  font-weight: ", ";\n  color: ", ";\n  margin-bottom: ", ";\n  text-transform: uppercase;\n"])), styleVariables.font.fontWeightNormal, function (props) {
  return props.theme.color.textSupport;
}, styleVariables.margin.small);
var StyledScoreLabel = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 10px;\n  font-weight: ", ";\n  color: ", ";\n  text-transform: uppercase;\n  text-align: center;\n"])), styleVariables.font.fontWeightNormal, function (props) {
  return props.theme.color.textSupport;
});
var StyledMainContent = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: ", ";\n"])), styleVariables.margin.medium);
var StyledLeftContent = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  flex: 1;\n  min-width: 0; /* Allow flex item to shrink */\n"])));
var StyledRightContent = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 60px;\n"])));
var StyledProgressContainer = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  margin-bottom: ", ";\n"])), styleVariables.margin.small, styleVariables.margin.small);
var StyledProgressBar = styled(Progress)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  width: 120px; /* Fixed width instead of flex: 1 */\n  .ant-progress-bg {\n    background-color: ", ";\n  }\n  .ant-progress-outer {\n    margin-right: 0;\n  }\n"])), styleVariables.colors.gray8);
var StyledPercentage = styled.span(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  min-width: 35px;\n  text-align: right;\n"])), styleVariables.font.fontSizeSmall, styleVariables.font.fontWeightStrong, function (props) {
  return props.theme.color.textPrimary;
});
var StyledScore = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  text-align: center;\n"])), styleVariables.font.fontSizeOriginal, styleVariables.font.fontWeightStrong, function (props) {
  return props.theme.color.textTitle;
});
var StyledGradingProcess = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-style: italic;\n  margin-bottom: ", ";\n"])), styleVariables.margin.small, function (props) {
  return props.theme.color.textSupport;
}, styleVariables.font.fontSizeSmall, styleVariables.margin.small);
var StyledAttendeeList = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  overflow-y: auto;\n  padding: ", " ", ";\n"])), styleVariables.padding.medium, styleVariables.padding.large);
var StyledWrapper = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral([""])));
export var AttendeeMenuComponent = function AttendeeMenuComponent(_ref) {
  var selectedAttendee = _ref.selectedAttendee,
      onSelectAttendee = _ref.onSelectAttendee,
      setCurrentAttendeeIndex = _ref.setCurrentAttendeeIndex,
      attendeeList = _ref.attendeeList,
      attendeeId = _ref.attendeeId,
      getAttendeeListStatus = _ref.getAttendeeListStatus,
      labels = _ref.labels,
      assignment = _ref.assignment;

  var handleSelectAttendee = function handleSelectAttendee(attendeeId) {
    if ((selectedAttendee === null || selectedAttendee === void 0 ? void 0 : selectedAttendee.id.toString()) === attendeeId) {
      return;
    }

    setCurrentAttendeeIndex((attendeeList === null || attendeeList === void 0 ? void 0 : attendeeList.findIndex(function (a) {
      return a.id.toString() === attendeeId;
    })) || 0);
    onSelectAttendee(attendeeId);
  };

  var renderProgressBar = function renderProgressBar(percent, isOnGradingProcess) {
    if (!percent) {
      return /*#__PURE__*/_jsxs(StyledProgressContainer, {
        children: [/*#__PURE__*/_jsx(StyledProgressBar, {
          percent: 0,
          showInfo: false,
          strokeColor: styleVariables.colors.colorPrimaryBase,
          trailColor: styleVariables.colors.gray8
        }), /*#__PURE__*/_jsx(StyledPercentage, {
          children: "0%"
        })]
      });
    }

    if (isOnGradingProcess) {
      return /*#__PURE__*/_jsxs(StyledGradingProcess, {
        children: [/*#__PURE__*/_jsx(LoadingOutlined, {}), /*#__PURE__*/_jsx("span", {
          children: labels.onGradingProcess
        })]
      });
    }

    return /*#__PURE__*/_jsxs(StyledProgressContainer, {
      children: [/*#__PURE__*/_jsx(StyledProgressBar, {
        percent: percent,
        showInfo: false,
        strokeColor: styleVariables.colors.colorPrimaryBase,
        trailColor: styleVariables.colors.gray8
      }), /*#__PURE__*/_jsxs(StyledPercentage, {
        children: [percent, "%"]
      })]
    });
  };

  var getScoreDisplay = function getScoreDisplay(attendee) {
    var _assignment$formRelea, _attendee$report$stat;

    var score = attendee.report.score;
    var totalScore = assignment === null || assignment === void 0 ? void 0 : (_assignment$formRelea = assignment.formReleaseInformation) === null || _assignment$formRelea === void 0 ? void 0 : _assignment$formRelea.totalScore;
    var emptyScoreDisplay = totalScore !== undefined && totalScore !== null ? "- / ".concat(totalScore) : '-';

    if (((_attendee$report$stat = attendee.report.status) === null || _attendee$report$stat === void 0 ? void 0 : _attendee$report$stat.id) !== SubmissionStatusId.SUBMITTED) {
      return emptyScoreDisplay;
    }

    if (score === SubmissionScore["default"].value) {
      return labels.onGrading;
    }

    if (typeof score !== 'number' || !Number.isFinite(score)) {
      return emptyScoreDisplay;
    }

    if (totalScore !== undefined && totalScore !== null) {
      return "".concat(score, " / ").concat(totalScore);
    }

    return score.toString();
  };

  var getAttendeeGradingResult = function getAttendeeGradingResult(attendee) {
    var _attendee$report$stat2, _assignment$displaySt;

    if (((_attendee$report$stat2 = attendee.report.status) === null || _attendee$report$stat2 === void 0 ? void 0 : _attendee$report$stat2.id) === SubmissionStatusId.BANNED) {
      return {
        text: labels.banned,
        color: styleVariables.colors.colorErrorBase
      };
    } // Submitted attendees: same result UI whether assignment is Upcoming or Ongoing.


    if (attendee.report.submitTime) {
      var _attendee$report;

      var gradedPercentage = attendee.report.gradedPercentage;

      if (gradedPercentage < 100) {
        return {
          text: labels.submitted,
          color: styleVariables.colors.colorPrimaryBase
        };
      }

      return (_attendee$report = attendee.report) !== null && _attendee$report !== void 0 && _attendee$report.isSubmissionPassed ? {
        text: labels.passed,
        color: styleVariables.colors.colorSuccessBase
      } : {
        text: labels.failed,
        color: styleVariables.colors.colorErrorBase
      };
    }

    if (assignment !== null && assignment !== void 0 && (_assignment$displaySt = assignment.displayStatus) !== null && _assignment$displaySt !== void 0 && _assignment$displaySt.isOnGoing()) {
      return {
        text: labels.ongoing,
        color: styleVariables.colors.colorPrimaryBase
      };
    }

    return {
      text: labels.submitted,
      color: styleVariables.colors.colorPrimaryBase
    };
  };

  var renderAttendeeList = function renderAttendeeList() {
    if (!attendeeList || getAttendeeListStatus === RequestStatus.EXECUTE) {
      return /*#__PURE__*/_jsx(StyledSkeleton, {
        active: true
      });
    }

    return /*#__PURE__*/_jsx(StyledAttendeeList, {
      children: attendeeList.map(function (attendee) {
        var isSelected = attendee.id.toString() === attendeeId;
        var isOnGradingProcess = attendee.report.isOnGradingProcess();
        var gradedPercentage = attendee.report.gradedPercentage;
        var gradingResult = getAttendeeGradingResult(attendee);
        return /*#__PURE__*/_jsx(StyledWrapper, {
          children: /*#__PURE__*/_jsx(Badge.Ribbon, {
            text: gradingResult.text,
            color: gradingResult.color,
            children: /*#__PURE__*/_jsxs(StyledAttendeeCard, {
              $isSelected: isSelected,
              onClick: function onClick() {
                return handleSelectAttendee(attendee.id.toString());
              },
              children: [/*#__PURE__*/_jsxs(StyledAttendeeName, {
                children: [attendee.firstName, " ", attendee.lastName]
              }), /*#__PURE__*/_jsxs(StyledMainContent, {
                children: [/*#__PURE__*/_jsxs(StyledLeftContent, {
                  children: [/*#__PURE__*/_jsx(StyledStatusLabel, {
                    children: labels.gradingStatus
                  }), renderProgressBar(gradedPercentage, isOnGradingProcess)]
                }), /*#__PURE__*/_jsxs(StyledRightContent, {
                  children: [/*#__PURE__*/_jsx(StyledScoreLabel, {
                    children: labels.score
                  }), /*#__PURE__*/_jsx(StyledScore, {
                    children: getScoreDisplay(attendee)
                  })]
                })]
              })]
            })
          })
        }, attendee.id.toString());
      })
    });
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderAttendeeList()
  });
};